import BaseAlert from './Alert';

// EXPORT
export const Alert = BaseAlert;
export type { AlertProps } from './Alert.interface';
